import React, { useState, useEffect } from "react";
import "./header.scss";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { AnimatePresence, motion, useAnimation } from "framer-motion";
import LoaderContext from "../../LoaderContext";

const Header = ({ active, setActive }) => {
  const controls = useAnimation();
  const { isLoading } = React.useContext(LoaderContext);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  React.useEffect(() => {
    if (!isLoading) {
      controls.start((i) => ({
        y: 0,
        opacity: 1,
        transition: { delay: i * 0.1 + 1.2 },
      }));
    } else {
      controls.start({ opacity: 0, y: 5 });
    }
  }, [isLoading, controls]);

  // Track mouse position for interactive effects
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div
      className="header"
      style={{
        "--mouse-x": `${mousePosition.x}px`,
        "--mouse-y": `${mousePosition.y}px`,
      }}
    >
      <AnimatePresence>
        <div className="header__content">
          <motion.div
            custom={0}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.5, duration: 1 }}
          >
            <motion.div
              animate={controls}
              custom={0}
              whileHover={{
                scale: 1.05,
                transition: { duration: 0.2 },
              }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="logo gradient-border">
                <Link to="/">
                  <motion.p
                    whileHover={{
                      textShadow: "0 0 20px rgba(255, 181, 16, 0.8)",
                      transition: { duration: 0.3 },
                    }}
                  >
                    HUMAIL
                  </motion.p>
                </Link>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            custom={0}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2, duration: 1 }}
          >
            <motion.div
              animate={controls}
              custom={1}
              whileHover={{
                scale: 1.05,
                transition: { duration: 0.2 },
              }}
              whileTap={{ scale: 0.95 }}
            >
              <Button
                variant="outlined"
                color="primary"
                startIcon={
                  <motion.div
                    animate={{ rotate: isHovering ? 360 : 0 }}
                    transition={{ duration: 0.5 }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <DownloadIcon />
                  </motion.div>
                }
                sx={{
                  width: "100%",
                  borderColor: "#ffb510",
                  py: 1,
                  color: "#ffb510",
                  borderRadius: "8px",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    borderColor: "#ff6b35",
                    backgroundColor: "rgba(255, 181, 16, 0.1)",
                    transform: "translateY(-3px)",
                    boxShadow: "0 10px 25px rgba(255, 181, 16, 0.3)",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-100%",
                    width: "100%",
                    height: "100%",
                    background:
                      "linear-gradient(90deg, transparent, rgba(255, 181, 16, 0.2), transparent)",
                    transition: "left 0.5s ease",
                  },
                  "&:hover::before": {
                    left: "100%",
                  },
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                href="https://mixlcquxckxf5utg.public.blob.vercel-storage.com/HumailSaleem_Resume.pdf"
                target="_blank"
                download
              >
                Download Resume
              </Button>
            </motion.div>
          </motion.div>

          <motion.div
            custom={2}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.5, duration: 1 }}
          >
            <motion.div
              animate={controls}
              custom={2}
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.2 },
              }}
              whileTap={{ scale: 0.9 }}
            >
              <div
                className={`menu-toggle ${active ? "active" : ""}`}
                onClick={() => setActive(!active)}
              >
                <motion.i
                  className="bx bx-menu"
                  animate={{
                    rotate: active ? 180 : 0,
                    opacity: active ? 0 : 1,
                  }}
                  transition={{ duration: 0.3 }}
                ></motion.i>
                <motion.i
                  className="bx bx-x"
                  animate={{
                    rotate: active ? 0 : -180,
                    opacity: active ? 1 : 0,
                  }}
                  transition={{ duration: 0.3 }}
                ></motion.i>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </AnimatePresence>
    </div>
  );
};

export default Header;
